import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useRouting } from '../../hooks';
// Replaces its own history entry so the Back button never lands on the redirecting page.
const Redirect = (props) => {
    const [, navigate] = useRouting();
    useEffect(() => {
        navigate(props.target, { 'replace': true });
    }, []);
    return _jsx(_Fragment, {});
};
export default Redirect;
